import { FunctionComponent } from "react";

export interface Props {
  className?: string;
  fill?: string;
  width?: number;
  height?: number;
}

const VergeHamburgerIcon: FunctionComponent<Props> = ({
  className = "",
  fill = "currentColor",
  width = 32,
  height = 32,
}) => {
  return (
    <svg
      className={className}
      width={width}
      height={height}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>Hamburger Navigation Button</title>
      <rect x="4" y="7" width="24" height="2" fill={fill} />
      <rect x="4" y="15" width="24" height="2" fill={fill} />
      <rect x="4" y="23" width="24" height="2" fill={fill} />
    </svg>
  );
};

export default VergeHamburgerIcon;
